import type {
  FieldErrors,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormReset,
  UseFormWatch,
} from "react-hook-form";
import type {
  Product,
  ProductFormSchema,
  ProductMediaItem,
} from "schemas/generated/product";
import type { ProductEmailFormBase } from "schemas/generated/productEmail";

import * as React from "react";

type ChangePropertyPayload = {
  key: keyof ProductFormSchema;
  value: ProductFormSchema[keyof ProductFormSchema];
  shouldDirty?: boolean;
};

type UpdateMediaPayload = {
  media: ProductMediaItem[];
  shouldDirty?: boolean;
};

export type ProductEditAction =
  | {
      type: "changeProperty";
      payload: ChangePropertyPayload;
    }
  | {
      type: "updateMedia";
      payload: UpdateMediaPayload;
    }
  | {
      type: "appendMedia";
      payload: {
        newMediaItem: ProductMediaItem;
        shouldDirty?: boolean;
      };
    }
  | {
      type: "addUploadingFileId";
      payload: {
        fileId: string;
      };
    }
  | {
      type: "removeUploadingFileId";
      payload: {
        fileId: string;
      };
    }
  | {
      type: "updateProductEmail";
      payload: {
        productEmail: ProductEmailFormBase;
        shouldDirty?: boolean;
      };
    };

type ProductEditContextType = {
  watch: UseFormWatch<ProductFormSchema>;
  reset: UseFormReset<ProductFormSchema>;
  dispatchProductEdit: (action: ProductEditAction) => void;
  hasDataChanged: boolean;
  isProductValid: boolean;
  handleReactHookFormSubmit: UseFormHandleSubmit<ProductFormSchema>;
  errors: FieldErrors<ProductFormSchema>;
  getValues: UseFormGetValues<ProductFormSchema>;
  isLoading: boolean;
  creatingNewProduct: boolean;
  isSubmitting: boolean;
  isSubmitted: boolean;
  product: Product;
};

export const ProductEditContext = React.createContext<
  ProductEditContextType | undefined
>(undefined);
